(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Mobile navigation
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-m-nav-toggle]');
    if (!toggle) return;
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  // Language: remember the visitor's choice, and follow the browser language on a first visit.
  const langNav = document.querySelector('[data-m-lang]');
  if (langNav) {
    const read = () => {
      try {
        return localStorage.getItem('mori-language');
      } catch (error) {
        return null;
      }
    };
    const remember = (code) => {
      try {
        localStorage.setItem('mori-language', code);
      } catch (error) {
        /* private browsing */
      }
    };

    langNav.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-code]');
      if (link) remember(link.dataset.code);
    });

    if (!read()) {
      const current = langNav.dataset.current;
      const links = [...document.querySelectorAll('[data-m-lang] a[data-code]')];
      const available = links.map((link) => link.dataset.code);
      const wanted = (navigator.languages || [navigator.language || ''])
        .map((code) => code.split('-')[0].toLowerCase())
        .find((code) => available.includes(code));

      if (wanted) {
        remember(wanted);
        const target = links.find((link) => link.dataset.code === wanted);
        if (wanted !== current && target) window.location.replace(target.href);
      }
    }
  }

  // Bag count
  const setBagCount = (count) => {
    document.querySelectorAll('[data-m-bag-count]').forEach((el) => {
      el.textContent = String(count);
    });
  };

  // Add to bag without leaving the page. Without JS the form posts to /cart/add as usual.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-m-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const label = button ? button.textContent : '';
    if (button) button.disabled = true;

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || form.dataset.errorLabel);

      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      setBagCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: form.id } }));

      if (button) button.textContent = form.dataset.addedLabel || label;
    } catch (error) {
      if (button) button.textContent = error.message || form.dataset.errorLabel || label;
    }

    window.setTimeout(() => {
      if (!button) return;
      button.textContent = label;
      button.disabled = false;
    }, 1600);
  });

  // Product image thumbnails
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-m-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-m-gallery]');
    const main = gallery && gallery.querySelector('.m-gallery-main');
    if (!main) return;
    main.src = thumb.dataset.src;
    main.srcset = thumb.dataset.srcset || '';
    main.alt = thumb.dataset.alt || '';
    gallery.querySelectorAll('[data-m-thumb]').forEach((el) => el.setAttribute('aria-current', String(el === thumb)));
  });

  // Variant picker: keep price and availability in sync
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-m-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const form = select.closest('form');
    const row = select.closest('[data-m-buy-row]');
    const price = row && row.querySelector('[data-m-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    const button = form && form.querySelector('[type="submit"]');
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? form.dataset.addLabel : form.dataset.soldOutLabel;
    }
  });
})();
